import React from 'react'
import * as Menu from '../../components/menu'
import * as Constants from './constants'

export const routes = [
  {
    action: () => import('./component'/* webpackChunkName:  "ForgotPasswordPage" */)
      .then(({ForgotPasswordPage}) => <ForgotPasswordPage />),
    path: Menu.AUTH_FORGOT_PASSWORD_URL,
  },
  {
    action: () => import('../success/component'/* webpackChunkName:  "SuccessPageComponent" */)
      .then(({SuccessPageComponent}) => <SuccessPageComponent heading={Constants.FORGOT_PASSWORD_SUCCESS_HEADING}
        content={Constants.FORGOT_PASSWORD_SUCCESS_CONTENT} />),
    path: Menu.AUTH_FORGOT_PASSWORD_SUCCESS_URL,
  },
]



// WEBPACK FOOTER //
// ./src/pages/forgot-password/routes.tsx